import { createSelector } from 'reselect';
const profilingState = state => state.profiling.company;
export const getUserCompany = createSelector(profilingState, (state) => state);
//# sourceMappingURL=selector.utils.js.map